import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nav-bar-header" }
const _hoisted_2 = { class: "nav-bar-nav" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { style: {"padding":"1rem"} }
const _hoisted_5 = {
  key: 0,
  class: "mobile-menu",
  "aria-label": "Open navigation menu"
}
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (link, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: index,
          href: link.href
        }, [
          _createVNode(_component_Icon, {
            icon: link.icon
          }, null, 8, ["icon"]),
          _createTextVNode(" " + _toDisplayString(" " + link.name), 1)
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "hamburger-menu",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("span", null, null, -1),
        _createElementVNode("span", null, null, -1),
        _createElementVNode("span", null, null, -1)
      ]))
    ]),
    (_ctx.isMenuOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (link, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: index,
              href: link.href
            }, [
              _createVNode(_component_Icon, {
                icon: link.icon
              }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(" " + link.name), 1)
            ], 8, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}